import { createGlobalStyle } from "styled-components";
import { rgba, darken } from "polished";
import {
  blue,
  cyan,
  green,
  magenta,
  orange,
  red,
  gray,
} from "@ant-design/colors";
import { getContrastColor } from "@lib/helpers/ColorHelper";

export const GlobalStyles = createGlobalStyle`
  html,
  body,
  #root {
    font-family: ${({ theme }) => theme.font.family};
    color: ${({ theme }) => theme.palette.text.primary};
    transition: all 0.3s ease;
  }

  :root {
    --Collapse-Color-1: ${() => magenta[6]};
    --Collapse-Color-2: ${() => cyan[6]};
    --Collapse-Color-3: ${() => green[6]};
    --Collapse-Color-4: ${() => orange[6]};
    --Collapse-Color-5: ${() => red[6]};
    --Collapse-Color-6: ${() => blue[6]};
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  ::-webkit-scrollbar {
    max-width: 8px;
    max-height: 8px;
    background-color: ${({ theme }) => theme.palette.background.default};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.palette.primary.main};

    &:hover {
      background-color: ${({ theme }) => darken(0.05, theme.palette.primary.main)};
      cursor: pointer;
    }
  }

  ::-webkit-scrollbar-corner {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .apexcharts-legend{
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: ${({ theme }) => theme.palette.background.default}!important;
    }

    &::-webkit-scrollbar {
      max-width: 8px;
      max-height: 8px;
      background-color: ${({ theme }) => theme.palette.background.default}!important;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: ${({ theme }) => theme.palette.primary.main}!important;

      &:hover {
        background-color: ${({ theme }) => darken(0.05, theme.palette.primary.main)}!important;
        cursor: pointer;
      }
    }

    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.palette.background.default}!important;
    }
  }

  .ant-table-wrapper{
    background-color: ${({ theme }) => theme.palette.background.default} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;

    .ant-table{
      color: ${({ theme }) => theme.palette.text.primary} !important;
      scrollbar-color: unset;
    }
  }

  canvas {
    display: block;
    height: 100%;
  }

  body {
    color: ${({ theme }) => theme.palette.text.primary};
    line-height: 1.35 !important;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${({ theme }) => theme.font.family};
    font-weight: ${({ theme }) => theme.font.weight.regular};

    @media screen and (min-width: ${({ theme }) =>
      theme.breakpoints.sm + 320}px ) {
      font-size: ${({ theme }) => theme.font.size.lg};
    }
  }

  .link {
    cursor: pointer;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  ul,
  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  b {
    font-weight: 500;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: 500;
    font-family: ${({ theme }) => theme.font.family};
  }

  h1 {
    font-size: 22px;
    font-weight: 600;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 18px;
  }

  h4 {
    font-size: 16px;
  }

  h5 {
    font-size: 14px;
  }

  h6 {
    font-size: 12px;
  }

  .pointer {
    cursor: pointer;
  }

  .text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .card-hover {
    transition: all 0.3s ease;
    transform: scale(1);

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, .45);
      transform: scale(1.05);
    }
  }

  .text-uppercase {
    text-transform: uppercase;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.palette.primary.main} !important;
  }

  .ant-btn{
  
    background: ${({ theme }) => theme.palette.background.secondary};
    color: contrast-color(${({ theme }) => theme.palette.background.secondary});

    &.ant-btn-variant-solid{
      box-shadow: unset;

      span {
        color:#fff;
      }
    }
      
    &.ant-btn-color-green{
      background-color: ${() => green[7]};
    }

    &.ant-btn-color-default{
      background: transparent;
      color: ${({ theme }) => theme.palette.text.primary};
      &:hover{
        background: ${({ theme }) => theme.palette.background.secondary};
        color: ${({ theme }) => theme.palette.text.primary};
      }
    }

    &:disabled {
      color: ${({ theme }) => theme.palette.text.disabled} !important;
    }

    span {
      color: inherit!important;
    }
  }


  button.ant-btn-primary {
    background: ${({ theme }) => theme.palette.primary.main} !important;
    border-color: ${({ theme }) => theme.palette.primary.main} !important;

    span{
      color: #fff!important;
    }

    &:hover,
    &:focus {
      background: ${({ theme }) =>
        darken(0.08, theme.palette.primary.main)} !important;
      border-color: ${({ theme }) =>
        darken(0.08, theme.palette.primary.main)} !important;
    }
  }

  .ant-btn-background-ghost.ant-btn-primary {
    color: ${({ theme }) => theme.palette.primary.main} !important;
    background: transparent !important;
    border-color: ${({ theme }) => theme.palette.primary.main} !important;

    &:hover,
    &:focus {
      color: ${({ theme }) =>
        darken(0.08, theme.palette.primary.main)} !important;
      background: transparent;
      border-color: ${({ theme }) =>
        darken(0.08, theme.palette.primary.main)} !important;
    }
  }

  .ant-segmented {
    color: ${({ theme }) => theme.palette.text.secondary} !important;
    background-color: transparent!important;
    
    .ant-segmented-item{
      border-radius: ${({ theme }) => theme.cardRadius} !important;
      margin: 1px 5px;
      user-select: none;
      background-color: ${({ theme }) =>
        theme.palette.background.default} !important;
      color: ${({ theme }) =>
        getContrastColor(theme.palette.background.default)} !important;
      border: 1px solid ${({ theme }) => theme.palette.borderColor} !important;

      &.ant-segmented-item-selected{
        background-color: ${({ theme }) =>
          theme.palette.primary.main} !important;
        color: ${({ theme }) =>
          getContrastColor(theme.palette.primary.main)} !important;
      }

      &.ant-segmented-item-disabled{
        background-color: transparent !important;
      }

      &.ant-segmented-item-focused{
        background-color: transparent !important;
      }

      &:active {
        border: unset!important;
        box-shadow: unset!important;
      }

      &:active::after {
        border: unset!important;
        box-shadow: unset!important;
      }

      &:hover::after {
        background-color: ${({ theme }) => theme.palette.primary.main} !important;
      }

      .ant-segmented-item-label {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
      }
    }

    .ant-segmented-thumb {
      background-color: ${({ theme }) => theme.palette.primary.main} !important;
    }
  }

  .ant-spin {
    color: ${({ theme }) => theme.palette.primary.main} !important;
  }

  .ant-splitter{
    position: relative;
    transition: all 0.3s ease;

    .ant-splitter-panel{
      position: relative;
      transition: all 0.3s ease;
    }

    .ant-splitter-bar{
      .ant-splitter-bar-dragger{
        &::after{
          background: ${({ theme }) => theme.palette.primary.main};
        }
      }
      .ant-splitter-bar-dragger:hover:not(.ant-splitter-bar-dragger-active)::before{
        background: ${({ theme }) => theme.palette.background?.splitter ?? theme.palette.background.default};
        width: 6px;
      }
      .ant-splitter-bar-dragger-active::before {
        background: ${({ theme }) => darken(0.11, theme.palette.background?.splitter ?? theme.palette.background.default)};
      }
    }
  }

  .ant-upload-wrapper {
  
    .ant-upload {
      background-color: ${({ theme }) => theme.palette.background.default} !important;
      color: ${({ theme }) => theme.palette.text.primary};
      border-radius: ${({ theme }) => theme.sizes.borderRadius.base};
      padding: ${({ theme }) => theme.sizes.borderRadius.base};
      transition: all 0.3s ease;
    }
  }
  .upload-preview{
    background-color: ${({ theme }) => theme.palette.background.default} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
    border-radius: ${({ theme }) => theme.sizes.borderRadius.base} !important;
    padding: ${({ theme }) => theme.spacing * 2} !important;
    transition: all 0.3s ease;

    .file-item {
      border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
      padding-bottom: ${({ theme }) => theme.sizes.borderRadius.base};
      margin-bottom: ${({ theme }) => theme.sizes.borderRadius.base};

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }

      .file-icon {
        width: 60px;
        height: 60px;
        background: ${({ theme }) => theme.palette.background.secondary};
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid ${({ theme }) => theme.palette.borderColor};
        box-shadow: 0 0 10px 0 ${({ theme }) => theme.palette.background.default};
      }
    }
  }

  .ant-dropdown {
    &.header-notify-messages {
      min-width: 370px !important;
    }
    &.no-padding {
      > .ant-dropdown-menu {
        padding: 0;

        .ant-dropdown-menu-item {
          padding: 0;
        }
      }
    }
  }

  .ant-list-item {
    justify-content: flex-start !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }

  .ant-spin-dot i,
  .ant-tabs-ink-bar {
    background: ${({ theme }) => theme.palette.primary.main} !important;
  }

  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.palette.primary.main} !important;
  }

  .text-lowercase {
    text-transform: lowercase;
  }

  .text-capitalize {
    text-transform: capitalize;
  }

  .text-left {
    text-align: left;

    [dir=rtl] & {
      text-align: right;
    }
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;

    [dir=rtl] & {
      text-align: left;
    }
  }

  .background-image {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .cr-btn {
    box-sizing: border-box;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    text-transform: uppercase;
  }

  .cr-btn-circle {
    background-color: transparent;
    border-color: transparent;
    color: ${({ theme }) => theme.palette.gray[500]};
    box-shadow: none;

    &:hover, &:focus {
      background-color: ${({ theme }) => theme.palette.tooltipBg + "04"};
      border-color: ${({ theme }) => theme.palette.tooltipBg + "04"};
      color: ${({ theme }) => theme.palette.text.primary};
    }

    & .anticon {
      font-size: 20px;
    }
  }

  .btn-secondary {
    background-color: ${({ theme }) => theme.palette.secondary.main};
    border-color: ${({ theme }) => theme.palette.secondary.main};
    color: ${({ theme }) => theme.palette.white};

    &:hover, &:focus {
      background-color: ${({ theme }) =>
        darken(0.25, theme.palette.secondary.main)} !important;
      border-color: ${({ theme }) =>
        darken(0.25, theme.palette.secondary.main)} !important;
      color: ${({ theme }) => theme.palette.white} !important;
    }
  }

  .btn-light-blue {
    background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};
    color: ${({ theme }) => theme.palette.primary.main};
    border-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};

    &:hover, &:focus {
      background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.2)};
      color: ${({ theme }) => theme.palette.primary.main};
      border-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.2)};
    }
  }

  .btn-secondary-outline {
    background-color: transparent;
    border-color: ${({ theme }) => theme.palette.secondary.main};
    color: ${({ theme }) => theme.palette.secondary.main};
    box-shadow: none;

    &:hover, &:focus {
      background-color: transparent;
      border-color: darken(0.15, ${({ theme }) =>
        theme.palette.secondary.main});
      color: darken(0.15, ${({ theme }) => theme.palette.secondary.main});
    }
  }

  .btn-primary-outline {
    background-color: transparent;
    border-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.main};
    box-shadow: none;

    &:hover, &:focus {
      background-color: transparent;
      border-color: darken(0.15, ${({ theme }) => theme.palette.primary.main});
      color: darken(0.15, ${({ theme }) => theme.palette.primary.main});
    }
  }

  .btn-white-outline {
    background-color: transparent;
    border-color: ${({ theme }) => theme.palette.white};
    color: ${({ theme }) => theme.palette.white};
    box-shadow: none;

    &:hover, &:focus {
      background-color: transparent;
      border-color: ${({ theme }) => theme.palette.white};
      color: ${({ theme }) => theme.palette.white};
    }
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .dot {
    height: 12px;
    width: 12px;
    display: block;
    border-radius: ${({ theme }) => theme.sizes.borderRadius.circle};
  }

  .close-btn {
    background-color: transparent;
    color: ${({ theme }) => theme.palette.text.primary};
    box-shadow: none;
    border: 0 none;
    padding: 0;
    height: auto;

    &:hover, &:focus {
      border: 0 none;
    }

    & .anticon {
      font-size: 20px;
    }
  }

  .page-title {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    margin-bottom: 16px;
    font-size: ${({ theme }) => theme.font.size.lg};
    display: inline-block;
  }

  .ant-checkbox-inner {
    width: 18px;
    height: 18px;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    width: 12px;
    height: 12px;
  }

  .ant-modal {
    max-width: 90%;
  }

  .text-secondary {
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .z-index-20 {
    z-index: 20;
  }

  .ant-pagination {
    & li {
      margin-bottom: 4px;
      margin-top: 4px;
      overflow: hidden;
    }

    &.mini {
      & .ant-pagination-item,
      & .ant-pagination-prev,
      & .ant-pagination-next {
        margin-bottom: 4px;
        margin-top: 4px;
      }
    }
  }

  .ant-drawer,
  .ant-modal-wrap,
  .ant-modal-mask,
  .ant-picker-dropdown,
  .ant-select-dropdown,
  .ant-message {
    z-index: 1051;
  }

  .ant-drawer-header{
    background-color: ${({ theme }) => theme.palette.background.default};
    .ant-drawer-close{
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }

  .ant-drawer-close {
    color: ${({ theme }) => theme.palette.text.primary};
    width: 36px;
    height: 36px;
    border-radius: 50%;
    top: 11px;
    right: 6px;
    padding: 5px;

    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.palette.background.default};
      color: ${({ theme }) => theme.palette.text.primary};

    }
  }

  .ant-tooltip-inner {
    & a {
      color: ${({ theme }) => theme.palette.white};
      display: flex;
      align-items: center;

      & .ant-menu-item-icon {
        margin-right: 6px;

        & .anticon, & svg {
          display: block;
        }
      }
    }
  }


  .item-hover {
    transition: all .2s ease;
    transform: scale(1);

    &:hover {
      background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};
      transform: translateY(-2px);
      box-shadow: 0 3px 10px 0 ${({ theme }) =>
        rgba(theme.palette.primary.main, 0.1)};
    }
  }


  .cr-dropdown-link {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${({ theme }) => theme.sizes.borderRadius.circle};
    color: ${({ theme }) => rgba(theme.palette.tooltipBg, 0.84)};
    font-size: 20px;

    &:hover {
      background-color: ${({ theme }) => rgba(theme.palette.tooltipBg, 0.1)};
    }
  }

  .slick-slider-global .slick-dots li {
    width: 12px;
    height: 12px;
    margin: 0 2px;
    vertical-align: middle;
  }

  .slick-slider-global .slick-dots li button {
    width: 12px;
    height: 12px;
    padding: 0;
  }

  .slick-slider-global .slick-dots li.slick-active button:before {
    color: #825a44;
    opacity: .75;
  }

  .slick-slider-global .slick-dots li button:before {
    width: 12px;
    height: 12px;
    font-size: 10px;
    line-height: 12px;
    color: #be8658;
  }

  .ant-card {
    border-radius: 16px;
    line-height: 1.35;
  }


  .ant-layout {
    position: relative;
 
    .ant-layout-header {
      padding-inline: 30px;

      @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
        padding-inline: 20px;
      }
    }

    .ant-layout-content{
      position: relative;
      color: ${({ theme }) => theme.palette.text.primary} !important;
    } 
  }

  .ant-btn, .ant-btn > .anticon {
    line-height: 1;
  }

  .ant-picker,
  .ant-picker-calendar-header,
  .ant-picker-panel,
  .ant-picker-body,
  .ant-picker-content,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-radio-input,
  .ant-radio-group,
  .ant-input,
  .ant-btn-circle,
  .ant-picker-cell-in-view,
  .ant-input-affix-wrapper,
  .ant-input-number-affix-wrapper,
  .ant-select-dropdown,
  .ant-dropdown-menu-title-content,
  .ant-drawer-content,
  .ant-list-item-meta-description,
  .ant-input-group-addon,
  .ant-input-group-addon > .ant-btn-icon-only {
    background: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary};
    border-color: ${(props) => props.theme.palette.borderColor} !important;
  }

  .ant-collapse {
    border-color: ${({ theme }) => theme.palette.background.default}; 
    overflow:hidden;    

    > .ant-collapse-item {
      border-bottom-color: transparent;  
      overflow:hidden;    

      > .ant-collapse-header {
        background: ${({ theme }) => theme.palette.background.default};
        color: ${({ theme }) => theme.palette.text.primary};
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-bottom-left-radius:0!important;
        border-bottom-right-radius:0!important;
      } 

      > .ant-collapse-content {
        border-top-color: ${({ theme }) => theme.palette.background.default};
        
        > .ant-collapse-content-box {
          color: ${({ theme }) => theme.palette.text.secondary};
          background: ${({ theme }) => theme.palette.background.paper};
        } 
      }
    }
  }

  .ant-switch {
    height:24px;
    border: 1px solid ${({ theme }) => theme.palette.background.paper};
  }

  .ant-slider {
    .ant-slider-rail {
      background: ${({ theme }) => theme.palette.text.secondary};
    }
  }

  .ant-image{
    overflow:hidden;
  }

  .ant-dropdown-menu{
    background: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
    
    .ant-dropdown-menu-item-selected{
      background: ${({ theme }) => theme.palette.background.default} !important;

      span{
        background: ${({ theme }) => theme.palette.background.default} !important;
      }
    }
  }

  .ant-select-item{
    background: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
    &.ant-select-item-option-active{
      background: ${({ theme }) => theme.palette.background.default} !important;
    }
  }

  
  .ant-radio-group {
    background: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;

    .ant-radio-button-wrapper{
      background: ${({ theme }) => theme.palette.background.paper} !important;
      color: ${({ theme }) => theme.palette.text.primary} !important;

      &.ant-radio-button-wrapper-checked{
        background: ${({ theme }) => theme.palette.background.default} !important;
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }
  }

  .ant-dropdown{
    .ant-table-filter-dropdown-btns{
      background: ${({ theme }) => theme.palette.background.paper} !important;
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    .ant-dropdown-menu-item{
      svg {
        color: ${({ theme }) => theme.palette.text.primary};
      }
    }

    .ant-dropdown-menu-title-content{
      a{
        color: ${({ theme }) => theme.palette.text.primary};
      }
      svg {
        color: ${({ theme }) => theme.palette.text.primary};
      }
    }

    .ant-dropdown-menu-submenu{
      .ant-dropdown-menu-submenu-title{
        svg {
          color: ${({ theme }) => theme.palette.text.primary} !important;
        }
      }
    }
    
    a.selected-menu-item {
      color: ${({ theme }) => theme.palette.text.disabled} !important;
      font-weight: 500;
    }
  }

  .ant-input-affix-wrapper {
    &.ant-input-disabled {
      span, 
      input{
        color: ${({ theme }) => theme.palette.text.disabled} !important;
      }
    }
  }

  .ant-input {
    &.ant-input-disabled {
      color: ${({ theme }) => theme.palette.text.disabled} !important;
    }
  }  

  .ant-input::placeholder,
  .ant-picker-input>input::placeholder,
  .ant-picker-input-placeholder>input,
  .ant-input-number-input {
    color: ${({ theme }) => theme.palette.text.secondary} !important;
    background: ${({ theme }) => theme.palette.background.paper} !important;
  }

  .ant-input-number{
    box-sizing:border-box;
    background: ${({ theme }) => theme.palette.background.paper} !important;
  
    @media print {
      border: none !important;
    }

    .ant-input-number-input-wrap{
    }

    
    .anticon{
      &.anticon-up,
      &.anticon-down{
        color: ${({ theme }) => theme.palette.text.primary} !important;
        svg{
          color: ${({ theme }) => theme.palette.text.primary} !important;
        }
      }
    }
  }
  
  .ant-input-number-handler-wrap {
    background: ${({ theme }) => theme.palette.background.paper} !important;
  }

  .ant-dropdown-trigger {
    background: transparent;
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }

  .ant-progress-text {
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }

  .anticon {
    background: transparent;
  }

  .ant-modal-content {
    background: ${({ theme }) => theme.palette.background.paper} !important;

    & .ant-modal-header {
      background: ${({ theme }) => theme.palette.background.paper} !important;

      & .ant-modal-title {
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }

    & .ant-modal-close-icon {
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }
  }

  .ant-card {
    background: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.text.primary};
    overflow: hidden;
    // border-radius: ${({ theme }) => theme.cardRadius};

    & .ant-card-body {
      padding: 0;
    }
  }

  .ant-radio-wrapper,
  .ant-list-item-meta-title,
  .ant-tabs-tab .ant-tabs-tab-btn,
  .ant-picker-content th,
  .ant-table-thead .ant-table-cell {
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }

  
  .ant-picker-cell,
  .ant-list-item-meta-description {
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .ant-checkbox-input {
    background-color: ${({ theme }) => theme.palette.background.paper};
  }

  .rnc__notification-container--top-right {
    right: 320px !important;
  }

  .rnc__notification-container--bottom-center,
  .rnc__notification-container--bottom-left {
    bottom: 200px !important;
  }

  .rnc__notification-container--bottom-right {
    bottom: 200px !important;
    right: 320px !important;
  }

  .boxedLayout {
    @media screen and (min-width: ${({ theme }) =>
      theme.breakpoints.xl + 80}px) {
      max-width: 1260px;
      margin-left: auto;
      margin-right: auto;

      #root {
        box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.12);
      }

      & .appMainFixedFooter {
        & .app-main-footer {
          max-width: 1260px;
          margin-left: auto;
          margin-right: auto;
        }
      }

      & .mini-sidebar-toggle.ant-layout-sider,
      & .mini-sidebar.ant-layout-sider,
      & .userMiniHeader-sidebar.ant-layout-sider {
        position: absolute;
      }

      & .app-header-mini-sidebar,
      & .app-header-mini,
      & .app-userMiniHeader {
        position: absolute;
        width: 100% !important;
      }

      & .mini-sidebar-toggle.ant-layout-sider-collapsed + .app-layout-mini-sidebar-main .app-header-mini-sidebar,
      & .mini-sidebar.ant-layout-sider-collapsed + .app-layout-mini-main .app-header-mini,
      & .userMiniHeader-sidebar.ant-layout-sider-collapsed + .app-layout-userMiniHeader-main .app-userMiniHeader {
        width: 100% !important;
      }

      & .app-layout-mini-sidebar,
      & .app-layout-mini,
      & .app-layout-userMiniHeader {
        padding-top: 0;
      }

      & .app-layout-mini-sidebar-main,
      & .app-layout-mini-main,
      & .app-layout-userMiniHeader-main {
        padding-top: 71px;
      }

      & .coin-stats-content h3 {
        font-size: ${({ theme }) => theme.font.size.lg};
      }

      & .coin-stats-content span {
        font-size: ${({ theme }) => theme.font.size.sm};
      }
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
      max-width: 1460px;

      & .appMainFixedFooter {
        & .app-main-footer {
          max-width: 1460px;
        }
      }
    }
  }

  .framedLayout {
    @media screen and (min-width: ${({ theme }) =>
      theme.breakpoints.xl + 80}px) {
      padding: ${({ theme }) => theme.sizes.borderRadius.base};
      background-color: ${({ theme }) => theme.palette.secondary.main};

      #root {
        height: calc(100vh - 2 * ${({ theme }) => theme.sizes.borderRadius.base});
        overflow: hidden;
        box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.12);
        border-radius: 12px;
      }

      &.framedHorLayout,
      &.framedHorDarkLayout,
      &.framedHorHeaderFixedLayout {

        #root {
          overflow-y: auto;
        }
      }

      & .app-sidebar-scrollbar,
      & .main-scrollbar,
      & .app-mini-sidebar-scrollbar,
      & .main-mini-sidebar-scrollbar,
      & .main-mini-scrollbar,
      & .standard-main-scrollbar,
      & .userHeader-main-scrollbar,
      & .main-userMiniHeader-scrollbar,
      & .drawerLayout-main-scrollbar,
      & .app-BitBucket-sidebar-scrollbar {
        max-height: calc(100vh - (71px + 2 * ${({ theme }) =>
          theme.sizes.borderRadius.base}));
      }

      & .app-standard-sidebar-scrollbar {
        max-height: calc(100vh - (140px + 2 * ${({ theme }) =>
          theme.sizes.borderRadius.base}));
      }

      & .app-userHeader-sidebar-scrollbar,
      & .app-sidebar-userMiniHeader-scrollbar,
      & .bitBucket-main-scrollbar,
      & .bucket-minibar {
        max-height: calc(100vh - (2 * ${({ theme }) =>
          theme.sizes.borderRadius.base}));
      }

      & .app-layout {
        height: calc(100vh - 2 * ${({ theme }) => theme.sizes.borderRadius.base});
        min-height: 10px;
      }

      & .auth {
        min-height: 10px;
        height: 100%;
      }

      & .main-auth-scrollbar {
        min-height: 10px;
      }

      & .apps-container {
        height: calc(100vh - (153px + 2 * ${({ theme }) =>
          theme.sizes.borderRadius.base}));
      }

      & .app-layout-mini-sidebar,
      & .app-layout-mini,
      & .app-layout-hor,
      & .app-layout-hor-header-fixed {
        min-height: 100%;
      }

      & .mini-sidebar-toggle.ant-layout-sider,
      & .mini-sidebar.ant-layout-sider,
      & .userMiniHeader-sidebar.ant-layout-sider {
        position: absolute;
      }

      & .app-header-mini-sidebar,
      & .app-header-mini,
      & .app-userMiniHeader {
        position: absolute;
        width: 100% !important;
      }

      & .mini-sidebar-toggle.ant-layout-sider-collapsed + .app-layout-mini-sidebar-main .app-header-mini-sidebar,
      & .mini-sidebar.ant-layout-sider-collapsed + .app-layout-mini-main .app-header-mini,
      & .userMiniHeader-sidebar.ant-layout-sider-collapsed + .app-layout-userMiniHeader-main .app-userMiniHeader {
        width: 100% !important;
      }

      & .app-layout-mini-sidebar,
      & .app-layout-mini,
      & .app-layout-userMiniHeader {
        padding-top: 0;
      }

      & .app-layout-mini-sidebar-main,
      & .app-layout-mini-main,
      & .app-layout-userMiniHeader-main {
        padding-top: 71px;
      }
    }
  }

  .ant-menu{
    background-color: ${({ theme }) => theme.palette.background.paper};
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    color: ${(props) => props.theme.palette.text.secondary} !important;
  }

  .ant-menu-item-group-title {
    color: ${(props) => props.theme.palette.text.secondary} !important;
  }

  .ant-menu-submenu {
    .ant-menu{
      background-color: ${({ theme }) => theme.palette.background.default} !important;
    }
  }

  
  .ant-menu-submenu-popup {
    background: transparent !important;
    
    .ant-menu {
      .ant-menu-item {
        height: 25px !important;
        width: 100% !important;
        display: flex;
        align-items: center;
      }
    }
  }

  .ant-table-wrapper.ant-columns-table{
    table {
      border: 1px solid ${({ theme }) => theme.palette.background.default} !important;

      thead {
        th{
          background-color: ${({ theme }) => theme.palette.background.default} !important;
        }

        >tr:first-child{
          display:none;
        }
      }
      tbody{
        tr{
          td{
            border: 1px solid ${({ theme }) => theme.palette.background.default} !important;
          }
        }
      }
    }
  }

  .ant-table-container{
    table {
      background-color: ${({ theme }) => theme.palette.background.paper} !important;
    }
      
    .ant-table-thead{
      th,td {
        color: ${(props) => props.theme.palette.text.primary} !important;
        background-color: ${({ theme }) => theme.palette.background.paper} !important;
      }
    }

    .ant-table-cell-row-hover {
      background-color: ${({ theme }) => theme.palette.background.default} !important;
    }

    .ant-table-placeholder{
      color: ${({ theme }) => theme.palette.text.primary} !important;
      background-color: ${({ theme }) => theme.palette.background.paper} !important;

      &:hover{
        background-color: ${({ theme }) => theme.palette.background.default} !important;

        td{
          background-color: ${({ theme }) => theme.palette.background.default} !important;
        }
      }

      .ant-empty-description{
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }
  }

  .ant-table-wrapper {
    .ant-table-container {
      border-color: ${({ theme }) => theme.palette.borderColor} !important;
      background-color: ${({ theme }) => theme.palette.background.paper} !important;
      // border-radius: 8px;

      table {
        background-color: ${({ theme }) => theme.palette.background.paper};
        border-color: ${({ theme }) => theme.palette.borderColor} !important;
        color: ${({ theme }) => theme.palette.text.primary} !important;

        article,
        span {
        }

        .ant-table-column-sort{
          background-color: ${({ theme }) => darken(0.01, theme.palette.background.default)} !important;

          &.ant-table-cell-row-hover {
            background-color: ${({ theme }) => darken(0.1, theme.palette.background.default)} !important;
          }
        }

        .ant-table-thead {
          tr {
            th {
              
              transition: all 0.1s ease;
              // background-color: ${({ theme }) => theme.palette.background.primary} !important;
              background-color: ${({ theme }) => darken(0.05, theme.palette.background.paper)} !important;
              border-start-start-radius: unset !important;
              border-start-end-radius: unset !important;
            }
          }
        }

        .ant-table-row { 
          transition: all 0.1s ease;
          
          .ant-table-cell {
            transition: all 0.1s ease;
            background-color: ${({ theme }) => theme.palette.background.paper} !important;

            &.ant-table-cell-row-hover {
              background-color: ${({ theme }) => darken(0.02, theme.palette.background.paper)} !important;
            }
          }

          .ant-table-cell-fix-left,
          .ant-table-cell-fix-right {
            background-color: ${({ theme }) => darken(0.02, theme.palette.background.paper)} !important;

            &.ant-table-cell-row-hover {
              background-color: ${({ theme }) => darken(0.04, theme.palette.background.paper)} !important;
            }
          }
        }
      }

      
    .ant-table-summary {
      position: sticky;
      bottom: 0;
      z-index: 1000;

      tr {
        &:first-child {
          .ant-table-cell{
            border-top: 2px solid ${({ theme }) => theme.palette.borderColor} !important;
          }
        }

        .ant-table-cell {
          background-color: ${({ theme }) => theme.palette.background.paper} !important;

          &.ant-table-cell-fix-left,
          &.ant-table-cell-fix-right {
            background-color: ${({ theme }) => darken(0.02, theme.palette.background.paper)} !important;
          }
        }
      }
    }

      .anticon svg {
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }

      .ant-table-expanded-row{
        background-color: ${({ theme }) => theme.palette.background.default} !important;
      }

      .ant-table-row-expand-icon{
        background-color: ${({ theme }) => theme.palette.background.paper} !important;
      
      }
    }  
      
    &.ant-striped-table {
      .ant-table-row:nth-child(odd) {
        .ant-table-cell {
          background-color: ${({ theme }) => darken(0.03, theme.palette.background.paper)} !important;

          &.ant-table-cell-row-hover {
            background-color: ${({ theme }) => darken(0.04, theme.palette.background.paper)} !important;
          }
        }

        .ant-table-cell-fix-left,
        .ant-table-cell-fix-right {
          background-color: ${({ theme }) => darken(0.04, theme.palette.background.paper)} !important;

          &.ant-table-cell-row-hover {
            background-color: ${({ theme }) => darken(0.06, theme.palette.background.paper)} !important;
          }
        }
        
      }
    }  
  }


  .ant-breadcrumb{
    color: ${({ theme }) => theme.palette.text.primary} !important;

    ol {
    align-items:end;

      li {
        color: ${({ theme }) => theme.palette.text.primary} !important;

        &:last-child {
          font-weight: ${({ theme }) => theme.font.weight.bold};
          font-size: ${({ theme }) => theme.font.size.lg};
        }
      }

      span {
        color: inherit;
        a {
          color: ${({ theme }) => theme.palette.text.primary} !important
        }
      }
    }

    .ant-breadcrumb-link{
      color: ${({ theme }) => theme.palette.text.primary} !important;    
    }
  }

  .ant-typography{
    color: ${({ theme }) => theme.palette.text.primary}!important;

    &.ant-typography-danger{
      color: ${() => red[6]}!important;
    }

    &.ant-typography-secondary{
      color: ${({ theme }) => theme.palette.text.secondary}!important;
    }

    &.clickable{
      color: ${({ theme }) => theme.palette.primary.main}!important;
    }
  }

  a.ant-typography,
  a.ant-typography span,
  a span.ant-typography{
    color: ${() => blue[4]}!important;
  }

  .ant-form {
    &.table-action-form{
      background-color: ${(props) => props.theme.palette.background.paper} !important;
      color: ${({ theme }) => theme.palette.text.secondary} !important;
    }
  }

  .ant-form-item {
    margin-bottom: 16px;

    label {
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    .ant-form-item-tooltip{
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    .ant-input-suffix{
      svg{
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }

    .ant-upload {
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    .ant-form-item-additional{
      color: ${({ theme }) => theme.palette.text.primary} !important;
      
      .ant-form-item-extra{
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }

    .ant-otp{
      width:100%;
    }

    .ant-picker {
      .ant-picker-range-separator {
        .ant-picker-separator {
          color: ${({ theme }) => theme.palette.text.primary} !important;
        }
      }
      .ant-picker-suffix{
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }
  }

  .ant-select {
    @media print {
      .ant-select-selector {
        border: none !important;

        .ant-select-selection-item{
          color: ${({ theme }) => theme.palette.text.primary} !important;
        }
      }

      .ant-select-arrow,
      .ant-select-clear {
        display: none !important;
      }
    }

    .ant-select-selector {
      border-color: ${(props) => props.theme.palette.borderColor} !important;
    }

    .ant-select-selection-placeholder{
      color: ${({ theme }) => theme.palette.text.secondary} !important;
    }

    .ant-select-clear svg{
      background-color: ${(props) => props.theme.palette.background.default} !important;
      color: ${({ theme }) => theme.palette.text.secondary} !important;
    }

    &.ant-select-disabled{
      span{
        color: ${({ theme }) => theme.palette.text.disabled} !important;
      }
    }
    .ant-select-arrow{
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }
  }

  .ant-picker-panel-layout {
    color: ${({ theme }) => theme.palette.text.secondary} !important;

    .ant-picker-panel {
      color: ${({ theme }) => theme.palette.text.secondary} !important;

      button {
        color: ${({ theme }) => theme.palette.text.secondary} !important;
      }

      .ant-picker-header,.ant-picker-content {
        color: ${({ theme }) => theme.palette.text.secondary} !important;
      }

      .ant-picker-time-panel-cell {
        .ant-picker-time-panel-cell-inner{
          color: ${({ theme }) => theme.palette.text.secondary} !important;
        }

        &.ant-picker-time-panel-cell-selected{
          .ant-picker-time-panel-cell-inner{
          background-color: ${(props) => props.theme.palette.background.default} !important;
          }
        }
      }
    }

    .ant-picker-footer {
      color: ${({ theme }) => theme.palette.text.secondary} !important;
      background-color: ${(props) => props.theme.palette.background.default} !important;
    }
  }

  .ant-divider{
      color: ${({ theme }) => theme.palette.text.secondary} !important;
      border-color: ${({ theme }) => theme.palette.background.secondary} !important;
        
  }

  .ant-alert {
    &.ant-alert-error {
      background-color: ${() => red[1]} !important;
      color: ${() => gray[9]} !important;
      border-color: ${() => red[2]} !important;
      .ant-alert-message{
        color: ${() => gray[9]} !important;
      }
      .ant-alert-description{
        color: ${() => gray[9]} !important;
      }
    }
    &.ant-alert-info {
      background-color: ${() => blue[1]} !important;
      color: ${() => gray[9]} !important;
      border-color: ${() => blue[2]} !important;
    }
    &.ant-alert-warning {
      background-color: ${() => orange[1]} !important;
      color: ${() => gray[9]} !important;
      border-color: ${() => orange[2]} !important;
    }
    &.ant-alert-success {
      background-color: ${() => green[1]} !important;
      color: ${() => gray[9]} !important;
      border-color: ${() => green[2]} !important;
    }
  }

  .ant-timeline {
    .ant-timeline-item {
      .ant-timeline-item-label {
        color: ${({ theme }) => theme.palette.text.secondary} !important;
      }
      .ant-timeline-item-tail {
        background-color: ${({ theme }) => theme.palette.background.secondary} !important;
      }
      .ant-timeline-item-head {
        background-color: ${({ theme }) => theme.palette.background.secondary} !important;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .ant-timeline-item-content {
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
    }
  }

  .ant-steps {
    .ant-steps-item{

      .ant-steps-item-title {
        color: ${({ theme }) => theme.palette.text.primary} !important;
      }
      .ant-steps-item-description {
        color: ${({ theme }) => theme.palette.text.secondary} !important;
        font-size: 12px;
      }
      .ant-steps-item-tail {
        color: ${({ theme }) => theme.palette.text.primary} !important;
        background-color: ${({ theme }) => theme.palette.background.secondary} !important;
      }
      .ant-steps-item-icon {
        background-color: ${({ theme }) => theme.palette.background.secondary} !important;
        .ant-steps-icon{
          color: #fff !important;
        }
      }

      &.ant-steps-item-finish {
        .ant-steps-item-tail {
          background-color: ${() => green[6]} !important;
          &::after {
            background-color: ${() => green[6]} !important;
          }
        }
        .ant-steps-item-icon {
          background-color: ${() => green[6]} !important;
        }
        .ant-steps-item-content{
          .ant-steps-item-title {
            &::after {
              background-color: ${() => green[6]} !important;
            }
          }
        }
      }
      
      &.ant-steps-item-process{
        .ant-steps-item-tail {
          border-color: ${() => green[6]} !important;
        }
        .ant-steps-item-icon {
          background-color: ${({ theme }) => theme.palette.background.secondary} !important;
          border-color: ${() => green[6]} !important;
          
          .ant-steps-icon{
            color: ${({ theme }) => theme.palette.text.primary} !important;
          }
        }
      }

      &.ant-steps-item-active {
      }
    }
  }

  .ant-descriptions{
    .ant-descriptions-item-label {
      color: ${({ theme }) => theme.palette.text.secondary} !important;
      background-color: ${({ theme }) => theme.palette.background.default} !important;
    }
    .ant-descriptions-item-content {
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    &.custom {
      .ant-descriptions-row {
        .ant-descriptions-item-label {
          padding: 2px 8px !important;
          border: 1px solid
            ${({ theme }) => theme.palette.background.paper} !important;
            
          color: ${({ theme }) => theme.palette.text.secondary} !important;
          background-color: ${({ theme }) => theme.palette.background.default} !important;

          text-align: right;

          &.warning{
            span{
              color: ${red[4]}!important;
            }
          }
        }

        .ant-descriptions-item-content {
          padding: 2px 8px !important;
          border: 1px solid
            ${({ theme }) => theme.palette.background.default} !important;
        }
      }
    }
  }

  .ant-empty-description{
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }

  .ant-popover{
    background-color: ${({ theme }) => theme.palette.background.paper};

    .ant-popover-inner{
      background-color: ${({ theme }) => theme.palette.background.paper};
    }

    .ant-popover-arrow{
      --antd-arrow-background-color: ${({ theme }) => theme.palette.background.paper};
    }
  }

  .ant-popconfirm-message {
    .ant-popconfirm-title {
      color: ${({ theme }) => theme.palette.text.primary} !important;
    }

    .ant-popconfirm-description {
      color: ${({ theme }) => theme.palette.text.secondary} !important;
    }
  }

  .ant-tag{
    background-color: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.text.primary};
    
    .ant-tag-has-color{
      color: #fff!important;
    }
  }

  .ant-divider {
    border-color: ${({ theme }) => theme.palette.borderColor} !important;
  }

  @media (max-width: 480px) {
    .ant-picker-panel-layout .ant-picker-panels {
      flex-direction: column !important;
    }
  }

  #invoice-drawer{
    .ant-drawer-header{
      @media print {
        display: none !important;
      }
    }
  }

  .no-print{
    @media print {
      display: none !important;
    }
  }
`;
